export default "__VITE_ASSET__CQ62wrmk__"